/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_EmptyInputs */

const cs_parties_empty = /** @type {(inputs: Parties_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné strany.`)
};

const en_parties_empty = /** @type {(inputs: Parties_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No parties yet.`)
};

/**
* | output |
* | --- |
* | "No parties yet." |
*
* @param {Parties_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_empty = /** @type {((inputs?: Parties_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_empty(inputs)
	return cs_parties_empty(inputs)
});